import { makeAutoObservable, runInAction } from "mobx";
import { history } from "../..";
import agent from "../api/agent";
import { User, UserFormValues, UserSearchListItem } from "../models/user";
import { store } from "./store";
import { toast } from "react-toastify";

export default class UserStore {
    user: User | null = null;
    userSearchResult: UserSearchListItem[] = [];
    loadingInitial = false;
    selectedUsers: string[] = [];
    isUserSelectedError: boolean = false;
    refreshTokenTimeout: any;

    constructor() {
        makeAutoObservable(this)
    }

    get isLoggedIn() {
        return !!this.user;
    }

    login = async (creds: UserFormValues) => {
        try {
            const user = await agent.Account.login(creds);
            store.commonStore.setToken(user.token);
            this.startRefreshTokenTimer(user);
            runInAction(() => this.user = user);
            history.push('/dashboard');
            store.modalStore.closeModal();
        } catch (error) {
            console.log(error);
            // throw error;
        }
    }

    logout = () => {
        store.commonStore.setToken(null);
        window.localStorage.removeItem('jwt');
        this.user = null;
        history.push('/');
    }

    getUser = async () => {
        try {
            const user = await agent.Account.current();
            if (user) {
                runInAction(() => this.user = user);
                this.startRefreshTokenTimer(user);
            } else this.logout();
        } catch (error) {
            //throw error;
            console.log(error);
        }
    }

    register = async (creds: UserFormValues) => {
        try {
            const user = await agent.Account.register(creds);
            store.commonStore.setToken(user.token);
            runInAction(() => this.user = user);
            history.push('/dashboard');
            store.modalStore.closeModal();
        } catch (error) {
            throw error;
        }
    }

    setImage = (image: string) => {

    }

    setDisplayName = (name: string) => {

    }

    fillUserSearchResult = async (searchKey: string) => {
        this.loadingInitial = true;
        try {
            const result = await agent.Users.get(searchKey);
            result.forEach(user => {
                this.userSearchResult.push(user);
            })
            this.loadingInitial = false;

        } catch (error) {
            console.log(error);
            this.loadingInitial = false;
        }
    }

    selectedUsersDelete = (toBeRemoved: string) => {
        try {
            this.selectedUsers = this.selectedUsers.filter(user => user !== toBeRemoved)
        }
        catch (error) {
            console.log(error);
        }
    }

    clearSelectedUsers = () => {
        try {
            this.selectedUsers = [];
        }
        catch (error) {
            console.log(error);
        }
    }

    refreshToken = async () => {
        this.stopRefreshTokenTimer();
        try {
            const user = await agent.Account.refreshToken();

            runInAction(() => (this.user = user));
            store.commonStore.setToken(user.token);
            this.startRefreshTokenTimer(user);
        } catch (error) {
            console.log(error);
            store.userStore.logout();
            toast.error("Session süresi doldu - Lütfen tekrar giriş yapınız");
        }
    };

    private startRefreshTokenTimer(user: User) {
        const jwtToken = JSON.parse(atob(user.token.split(".")[1]));
        const expires = new Date(jwtToken.exp * 1000);
        const timeout = expires.getTime() - Date.now() - 30 * 1000;
        this.refreshTokenTimeout = setTimeout(this.refreshToken, timeout);
    }

    private stopRefreshTokenTimer() {
        clearTimeout(this.refreshTokenTimeout);
    }
}